exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nth[data-v-2d21423a] {\n  font-size: 13px;\n  font-family: Roboto;\n}\ntd[data-v-2d21423a] {\n  font-size: 12px;\n  font-family: Roboto;\n}\nlabel[data-v-2d21423a] {\n  font-weight: 800;\n  color: black;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d21423a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/components/crossDockMaterialVisibility/crossDockMaterialVisibility.component.scss
// module id = 2154
// module chunks = 0